"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeatureOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const containerRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setMousePosition({
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        });
      }
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener("mousemove", handleMouseMove);
      return () => container.removeEventListener("mousemove", handleMouseMove);
    }
  }, []);
  return <section id="feature-overview" ref={node => {
    (sectionRef as React.MutableRefObject<HTMLElement | null>).current = node;
    (containerRef as React.MutableRefObject<HTMLElement | null>).current = node;
  }} className="relative overflow-hidden bg-dark-section text-dark-foreground py-24 md:py-32" style={{
    background: `radial-gradient(circle 600px at ${mousePosition.x}px ${mousePosition.y}px, hsla(221, 83%, 53%, 0.15), transparent 50%), hsl(0, 0%, 10%)`
  }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="text-[36px] md:text-[42px] leading-[1.3] font-bold tracking-[-0.2px] text-dark-foreground mb-6">
              Proactive Accountants Who Care
            </h2>
            <p className="text-[16px] md:text-[18px] leading-[1.6] text-dark-foreground/80">
              At Sloane, we go beyond traditional number-crunching. Our team of dedicated professionals provides strategic financial guidance tailored to your business needs, helping you make informed decisions that drive growth and profitability.
            </p>
          </div>

          <div className={`flex justify-center lg:justify-end transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover rounded-[var(--radius-full)] px-8 py-4 text-base font-semibold shadow-medium hover:shadow-strong hover:-translate-y-0.5 active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-out focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring">
              <Link to="/ServicesPage">Explore Our Services</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}